import { Component, OnInit } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import moment from "moment";

@Component({
  selector: "app-upcoming-tab",
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, TranslateModule],
  template: `
    <div class="upcoming-tabs-container">
      <div class="sub-tabs">
        @for (tab of subTabs; track tab.date) {
          <a class="sub-tab-link" [routerLink]="['date', tab.date]" routerLinkActive="active">
            {{ tab.label }}
          </a>
        }
      </div>
      <div class="sub-tab-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [
    `
      .upcoming-tabs-container {
        display: flex;
        flex-direction: column;

        .sub-tabs {
          display: flex;
          background-color: #fafafa;
          gap: 4px;
          position: sticky;
          top: 42px;
          z-index: 10;
          width: 100%;
          padding: 8px 0;

          .sub-tab-link {
            flex: 1;
            padding: 0.4rem 1rem;
            text-align: center;
            text-decoration: none;
            color: #7c8fac;
            background-color: #f5f7f9;
            font-weight: 600;
            font-size: 0.85rem;
            border-radius: 4px;
            letter-spacing: 0.5px;
            text-transform: uppercase !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: pointer;

            &:hover:not(.active) {
              color: #ffba00;
              background-color: rgba(255, 186, 0, 0.02);
            }

            &.active {
              background-color: #ffba00;
              color: #000000;
              font-weight: 600;
            }
          }
        }

        .sub-tab-content {
          margin-top: 4px;
        }
      }
    `,
  ],
})
export class UpcomingTabComponent implements OnInit {
  subTabs: any[] = [];

  ngOnInit() {
    const today = moment();
    const tomorrow = moment().add(1, "days");
    const dayAfter = moment().add(2, "days");

    this.subTabs = [
      { label: today.format("MMM DD, YYYY"), date: "today" },
      { label: tomorrow.format("MMM DD, YYYY"), date: "tomorrow" },
      { label: dayAfter.format("MMM DD, YYYY"), date: "dayAfter" },
    ];
  }
}
